export default "__VITE_ASSET__DCTVScVH__"